import api from './api';

export async function getSavingsSummary() {
  const res = await api.get('/savings/summary');
  return res.data;
}

export async function createSavingsEntry({ amount, pool, entryDate }) {
  const body = { amount, pool };
  if (entryDate) body.entry_date = entryDate;
  const res = await api.post('/savings/entries', body);
  return res.data;
}

export async function deleteSavingsEntry(entryId) {
  await api.delete(`/savings/entries/${entryId}`);
}
